import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Config from 'root/config';
import Router from 'root/router';
import Util from 'root/module/util';
import Form from 'root/module/form';
import SVG from 'root/module/svg_icon';
import View from 'view/base';
import View_Empty_Profile from 'view/empty_profile';
import View_Workspace_Select from 'view/workspace/login_select';
import { PublicClientApplication } from "@azure/msal-browser";

export default View.extend({
    className: 'login',

    form_display: 'login',
    user_id: '',
    signup_code: '',
    signup_plan: '',
    campaign_code: '',
    referral_code: '',
    error_message: '',
    email: '',
    password:'',
    fullname: '',

    views: {
        workspace_select: {},
        empty_profile: {}
    },

    events: {
        'submit .login-auth'                : 'login',
        'submit .login-2fa'                 : 'login2FA',
        'submit .openid-password-confirm'   : 'openidPasswordConfirm',
        'submit .signup-method-email'       : 'continueWithEmail',
        'click .signup-method-back'         : 'continueWithEmailBack',
        'submit #gtm_signup_form'           : 'signup',
        'submit .signup-confirm'            : 'signupConfirm',
        'submit .forgot-password-form form' : 'forgotPasswordSubmit',
        'submit .reset-password-form form'  : 'resetPassword',
        'submit .invite-auth'               : 'acceptUserInvitation',
        'click .login-form .code-resend a'  : 'resendCode',
        'click .password-toggle'            : 'onTogglePassword',
        'click .openid-button-microsoft'    : 'onMicrosoftLogin',
        'click .openid-button-sso'          : 'onSSOLogin'
    },

    dom_handlers: {
        // email / password login
        login: function(e, email, password, onboarding) {
            let form_data;

            if (email && password) {
                form_data = {
                    email    : email,
                    password : password
                };
            } else {
                form_data = Form.getData(this.$el.find('.login-auth'));
            }

            if (this.ext_login) {
                form_data.ext_login = true;
            }

            this.email    = form_data.email;
            this.password = form_data.password;

            this.$el.find('.sign-in').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'app/login',
                data: form_data,
                anon: true,
                success: (response) => {
                    if (typeof response.sso_domain !== 'undefined') {
                        window.location = app_configs.sso_login_url;
                        return;
                    } else if (response.authenticated === false) {
                        // wrong email or password
                        this.$el.find('.banner-danger')
                            .text('You entered an incorrect email, password, or both.')
                            .show();
                    } else if (response['2fa']) {
                        // 2FA
                        this.$el.find('.login-form div[data-step="1"]').hide();
                        this.$el.find('.login-form div[data-step="2"]').find('.2fa-email').text(this.email);
                        this.$el.find('.login-form div[data-step="2"]').show().find('input:first').focus();
                    } else {
                        // logged in

                        // set configs because ssoRedirect needs it
                        Cache.app.configs = response.configs;

                        var sso_redirect = this.checkSSORedirect();

                        if (sso_redirect) {
                            return;
                        }

                        // empty user profile
                        if (response.user_id && response.error_msg === 'no workspaces') {
                            // hack
                            $('<div>')
                                .addClass('workspace-form')
                                .append($('<div>').addClass('region-workspace-select'))
                                .insertAfter(this.$el.find('.login-form'));

                            this.$el.find('.login-form').hide();

                            this.views.empty_profile = new View_Empty_Profile({
                                email    : form_data.email,
                                password : form_data.password,
                                user_id  : response.user_id
                            });
                            this.views.empty_profile.render().$el.appendTo(this.$el.find('.region-workspace-select'));

                            this.views.empty_profile.on('success', () => {
                                this.dom_handlers.login.call(this, null, form_data.email, form_data.password, true);
                            });
                        } else if (response.error_msg) {
                            this.$el.find('.banner-danger')
                                .text(response.error_msg)
                                .show();
                        } else {
                            if (this.ext_login) {
                                this.loginToExt(response.auth_key);
                            } else {
                                this.loginToApp(response, onboarding);
                            }
                        }
                    }
                },
                complete: () => {
                    this.$el.find('.sign-in').prop('disabled', false).removeClass('loading');
                }
            });
        },

        // 2FA code
        login2FA: function(e) {
            var code_2fa = '';

            this.$el.find('.login-2fa input').each(function() {
                code_2fa += $(this).val();
            });

            // submit
            this.$el.find('.login-2fa input').prop('disabled', true);
            this.$el.find('.login-2fa .banner-danger').hide();

            Cache.app.request({
                action: 'app/login',
                data: {
                    email    : this.email,
                    password : this.password,
                    code     : code_2fa,
                    ext_login: this.ext_login ? true : undefined // use undefined to hide the data in the payload when observing the network tab
                },
                anon: true,
                success: (response) => {
                    if (response.error_msg) {
                        this.$el.find('.login-2fa input').prop('disabled', false);
                        this.$el.find('.login-2fa .banner-danger').text(response.error_msg).show();

                        return;
                    }

                    if (response.authenticated === false) {
                        this.$el.find('.login-2fa input').prop('disabled', false);
                        this.$el.find('.login-2fa .banner-danger').text('Invalid code').show();

                        return;
                    }

                    // set configs because ssoRedirect needs it
                    Cache.app.configs = response.configs;

                    var sso_redirect = this.checkSSORedirect();

                    if (sso_redirect) {
                        return;
                    }

                    if (this.ext_login) {
                        this.loginToExt(response.auth_key);
                    } else {
                        this.loginToApp(response);
                    }
                }
            });

            return;
        },

        // confirm password for openid sign in when converting an existing email login
        openidPasswordConfirm: function() {
            var password = Form.getData(this.$el.find('.openid-password-confirm'), 'password');
            this.openidSignin(this.openid_provider, this.openid_payload, {...this.openid_options, password: password});

            this.$el.find('.openid-password-confirm button:submit').prop('disabled', true).addClass('loading');
        },

        continueWithEmail: function() {
            var email = Form.getData(this.$el.find('.signup-method-email'), 'email');
            var submit_btn = this.$el.find('.signup-method-email button:submit');

            submit_btn.addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'app/registerValidate',
                cache: 120,
                data: {
                    email: email
                },
                success: (response) => {
                    var error_banner = this.$el.find('.signup-method-email .banner-danger');

                    if (response.error_msg) {
                        error_banner.text(response.error_msg).show();
                    } else if (typeof response.sso_domain !== 'undefined') {
                            this.form_display = 'sso_domain';
                            this.render();
                    } else {
                        error_banner.text('').hide();

                        Form.setData(this.$el.find('#gtm_signup_form'), {
                            email: email
                        });

                        this.toggleEmailSignupForm(true);
                        this.$el.find('#gtm_signup_form').find('input[name="name"]').focus();
                    }
                },
                complete: () => {
                    submit_btn.removeClass('loading').prop('disabled', false);
                }
            });
        },

        continueWithEmailBack: function() {
            this.toggleEmailSignupForm(false);
        },

        signup: function() {
            var form_data = Form.getData(this.$el.find('.signup-form form'));

            if (this.signup_code) {
                form_data['signup_code'] = this.signup_code;
            }

            if (this.signup_plan) {
                form_data['signup_plan'] = this.signup_plan;
            }

            if (this.campaign_code) {
                form_data['campaign_code'] = this.campaign_code;
            }

            if (this.join_code) {
                form_data['join_code'] = this.join_code;
            }

            if (typeof Intl !== 'undefined') {
                var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                if (timezone) {
                    if (typeof Config.timezone_list[timezone] === 'undefined') {
                        // the timezone key is not identical
                        // try to find it
                        var timezone_info = timezone.split('/');

                        if (timezone_info.length === 2) {
                            var city = timezone_info[1];

                            _.each(Config.timezone_list, (cities, timezone_name) => {
                                if (cities.toLowerCase().indexOf(city.toLowerCase()) !== -1) {
                                    timezone = timezone_name;
                                }
                            });
                        }
                    }

                    if (typeof Config.timezone_list[timezone] !== 'undefined') {
                        form_data.timezone = timezone;
                    }
                }
            }

            this.$el.find('.signup-form').addClass('loading');
            this.$el.find('.signup-form form button').prop('disabled', true).addClass('loading');
            this.$el.find('.banner-danger').hide();

            Cache.app.request({
                action: 'app/register',
                data: form_data,
                anon: true,
                success: (response) => {
                    if (typeof response.sso_domain !== 'undefined') {
                        this.form_display = 'sso_domain';
                        this.render();
                    } else if (typeof response.user !== 'undefined') {
                        // existing user joins via workspace invite link

                        // HACK:
                        // re-render the login page with the new form_display
                        // so the 2FA form will be there in the UI
                        this.form_display = 'login';
                        this.render();
                        this.dom_handlers.login.call(this, null, form_data.email, form_data.password, false);
                    } else if (response.error_msg) {
                        if (response.error_msg === 'account_exists') {
                            Router.navigate('/login/?redirect=signup&email=' + form_data.email, {trigger: true});
                        } else {
                            this.$el.find('.banner-danger')
                            .text(response.error_msg)
                            .show();
                            this.$el.find('.signup-form').removeClass('loading');
                        }
                    } else {
                        // confirmation code
                        this.$el.find('.banner-danger').hide();
                        this.$el.find('.signup-form div[data-step="1"]').hide();
                        this.$el.find('.signup-form div[data-step="2"]').show().find('input:first').focus();

                        this.$el.find('.signup-form .confirm-name').text(form_data.name);
                        this.$el.find('.signup-form .confirm-email').text(form_data.email);

                        Router.navigate('/signup/confirm', {trigger: false});
                    }
                },
                complete: () => {
                    this.$el.find('.signup-form').removeClass('loading');
                    this.$el.find('.signup-form form button').prop('disabled', false).removeClass('loading');
                }
            });
        },

        signupConfirm: function() {
            var confirmation_code = '';

            this.$el.find('.signup-confirm input').each(function() {
                confirmation_code += $(this).val();
            });

            // submit
            this.$el.find('.signup-confirm input').prop('disabled', true);
            this.$el.find('.signup-confirm .banner-danger').hide();

            var form_data = Form.getData(this.$el.find('.signup-form form'));

            Cache.app.request({
                action: 'app/registerConfirm',
                data: {
                    email : form_data.email,
                    code  : confirmation_code
                },
                anon: true,
                success: (response) => {
                    if (this.join_code) {
                        // workspace invite link
                        this.loginToApp(response);
                    } else {
                        // account signup
                        this.loginToApp(response, true);

                        // tracking
                        this.trackSignup();
                    }
                },
                error: () => {
                    this.$el.find('.signup-confirm input').prop('disabled', false);

                    this.$el.find('.signup-confirm .banner-danger').text('Invalid code').show();
                    this.$el.find('.signup-confirm .banner-success').hide();
                }
            });
        },

        forgotPasswordSubmit: function() {
            var form_data = Form.getData(this.$el.find('.forgot-password-form form'));

            this.$el.find('.forgot-password-form form button').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'app/forgotPassword',
                data: form_data,
                anon: true,
                success: () => {
                    this.$el.find('.banner-success').html('If an account exists for <b>' + Util.htmlEntities(form_data.email) + '</b>, you will get an email with instructions on resetting your password.').show();
                },
                complete: () => {
                    this.$el.find('.forgot-password-form form button').prop('disabled', false).removeClass('loading');
                }
            });
        },

        resetPassword: function() {
            var form_data = Form.getData(this.$el.find('.reset-password-form form'));

            this.$el.find('.reset-password-form button:submit').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'app/resetPassword',
                data: form_data,
                anon: true,
                success: (response) => {
                    if (response.error_msg) {
                        this.$el.find('.reset-password-form .banner-success').hide();
                        this.$el.find('.reset-password-form .banner-danger').text(response.error_msg).show();
                    } else {
                        this.$el.find('.reset-password-form .banner-danger').hide();
                        this.$el.find('.reset-password-form .banner-success').text('Password reset successfully').show();
                    }
                },
                complete: () => {
                    this.$el.find('.reset-password-form button:submit').prop('disabled', false).removeClass('loading');
                }
            });
        },

        acceptUserInvitation: function() {
            var form_data = Form.getData(this.$el.find('.invite-auth'));

            this.$el.find('.join-submit').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'account/acceptUserInvitation',
                data: form_data,
                anon: true,
                success: (response) => {
                    if (response && response.error_msg) {
                        this.$el.find('.banner-danger')
                            .text(response.error_msg)
                            .show();
                    } else {
                        // success
                        this.loginToApp(response);
                    }
                },
                complete: () => {
                    this.$el.find('.join-submit').prop('disabled', false).removeClass('loading');
                }
            });
        },

        resendCode: function(e) {
            e.preventDefault();

            Cache.app.request({
                action: 'app/login',
                data: {
                    email : this.email,
                    password : this.password,
                },
                anon: true,
                success: (response) => {
                    if (!response) {
                        return;
                    }

                    if (response.error_msg) {
                        this.$el.find('form input').prop('disabled', false);
                        this.$el.find('.login-form div[data-step="2"] .banner-danger').text(response.error_msg).show();
                        return;
                    }

                    UI.success('We\'ve sent you a new login code.');
                }
            });

            this.$el.find('.login-form .code-resend').html('&nbsp;');
        },

        onTogglePassword: function(e) {
            $(e.currentTarget).toggleClass('active').prev().attr('type', (index, attr) => {
                return attr === 'password' ? 'text' : 'password';
            });
        },

        onMicrosoftLogin: function(e) {
            const login_request = {
                scopes: ['profile', 'email'],
            };

            this.msal_instance.loginPopup(login_request).then((response) => {
                this.openidSignin('microsoft', response, {});
            }).catch((error) => {
                console.error('Error during Microsoft login:', error);
            });
        },

        onSSOLogin: function(e) {
            // redirect_uri
            var state = '';
            var sep = window.app_configs.sso_login_url.indexOf('?') === -1 ? '?' : '&';

            if (this.ext_login) {
                state = sep + 'state=ext_login';
            } else if (Cache.login_redirect) {
                state = sep + 'state='+ encodeURIComponent(Cache.login_redirect);
            }

            window.location = window.app_configs.sso_login_url + state;
        },
    },

    loginToExt: function(auth_key) {
        const event = new CustomEvent('ext_login', {
            detail: {
                auth_key: auth_key
            }
        });
        window.dispatchEvent(event);
    },

    loginToApp: function(data, onboarding) {
        // app config
        Cache.app.configs = data.configs;

        // data
        Cache.app.setData(data);

        if (onboarding) {
            Router.navigate('/setup/', {trigger: true});
        } else {
            if (data.workspace && data.workspace.length === 1) {
                // one workspace or using a workspace url
                if (Cache.login_redirect) {
                    this.loginRedirect(Cache.login_redirect);
                    Cache.login_redirect = undefined;
                } else {
                    this.loginRedirect('/project/');
                }
            } else {
                // using a workspace url
                if (Cache.getDefaultWorkspace().getUrl() === document.location.origin && document.location.origin !== Cache.app.host) {
                    this.loginRedirect('/project/');
                    return;
                }

                Router.navigate('/workspace/', {trigger: true});
            }
        }

        Cache.app.identifyUser();
        Cache.app.intercomSync();
        Cache.app.trackEvent('Login', {LastLogin: Math.floor(Date.now() / 1000)}, true);
    },

    trackSignup: function(signup_provider) {
        Cache.app.trackEvent('Signup', {
            provider: signup_provider || 'email'
        }, true);

        if (Cache.app.debug) {
            return;
        }

        try {
            // GA4 event
            if (typeof dataLayer === 'object') {
                dataLayer.push({
                    'event': 'successful_signup_confirm'
                });
            }

            if (typeof gtag === 'function') {
                // Google Ads
                gtag('event', 'conversion', {'send_to': 'AW-871130930/HUL4CPeC7fgBELLOsZ8D'});
            }

            // Facebook
            if (typeof fbq === 'function') {
                fbq('track', 'CompleteRegistration', {
                    currency : 'USD',
                    value    : 0
                });
                fbq('track', 'Lead');
            }

            // LinkedIn
            if (typeof lintrk === 'function') {
                // Conversion name:  Trial Confirm
                window.lintrk('track', { conversion_id: 10552460 });
            }
        } catch (e) {
        }
    },

    checkSSORedirect: function() {
        var redirect_url = Router.getQueryString('redirect_url');

        if (redirect_url) {
            var sso_success = this.ssoRedirect(redirect_url);

            if (sso_success) {
                return true;
            }
        }

        return false;
    },

    ssoRedirect: function(redirect_url) {
        Cache.app.request({
            action: 'app/ssoHelpCenter',
            data: {
                redirect_url: redirect_url
            },
            success: function(response) {
                window.location = response.sso_url;
            }
        });

        return true;
    },

    loginRedirect: function(redirect_url) {
        if (redirect_url === 'intercom_oauth') {
            window.location = Cache.app.configs.api_host + 'intercom/install';
        } else if (Cache.getDefaultWorkspace().getUrl() === document.location.origin) {
            // SPA redirect when im already on the workspace url
            Router.navigate(redirect_url, {trigger: true});
        } else {
            // window refresh when im on the generic host
            window.location = Cache.app.host + redirect_url;
        }
    },

    initialize: function(options) {
        this.signup_code    = Router.getQueryString('c');
        this.error_message  = Router.getQueryString('e');
        this.error_code     = Router.getQueryString('ec');
        this.email          = Router.getQueryString('email');
        this.fullname       = Router.getQueryString('name');

        var redirect = Router.getQueryString('redirect');

        this.ext_login = redirect === 'extension';
        Cache.login_redirect = redirect && redirect.indexOf('/login') === -1 ? redirect : '';

        // combine utm parameters
        var campaign_code = [];
        var utm_params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'via'];
        utm_params.forEach((param) => {
            var value = Router.getQueryString(param);
            if (value) {
                campaign_code.push(value);
            }
        });

        this.campaign_code = campaign_code.join('_');
        this.signup_plan = Router.getQueryString('plan') || '';

        if (Cache.get('referral_code')) {
            this.referral_code = Cache.get('referral_code');
        }

        this.signin_context = '';

        if (!options) {
        } else if (options.signup === true) {
            this.form_display = 'signup';
            this.signin_context = 'signup';
            this.referral_code = options.referral_code;

            Cache.add('referral_code', this.referral_code, false);
        } else if (options.forgot_password === true) {
            this.form_display = 'forgot_password';
        } else if (options.reset_password === true) {
            this.form_display = 'reset_password';
            this.password_reset_key = options.password_reset_key;
        } else if (options.user_invitation === true) {
            this.form_display = 'user_invitation';
            this.signin_context = 'signin';
            // support both old (/invitation/xxx) and new (invitation/?id=xxx)
            if (!options.invitation_key) {
                options.invitation_key = Router.getQueryString('id');
            }
            this.invitation_key = options.invitation_key;
        } else if (options.join === true) {
            this.form_display = 'join_workspace';
            this.join_code = options.join_code;
        } else if (options.workspace_select === true && Cache.real_user_id) {
            this.form_display = 'workspace_select';
        }

        if (this.form_display === 'login') {
            this.signin_context = 'signin';
        }
    },

    onPageReady: function() {
        if (this.error_message) {
            UI.error(this.error_message);
        }

        if (this.form_display === 'user_invitation') {
            // user invitation email
            Cache.app.request({
                action: 'app/getInvitation',
                data: {
                    key: this.invitation_key
                },
                anon: true,
                error: () => {
                    this.$el.find('.banner-danger').text('The invitation link has expired.').show();
                    this.$el.find('.join-submit').prop('disabled', true);
                    this.$el.find('#openid_signin_methods').addClass('disabled');
                },
                success: (response) => {
                    if (response.workspace) {
                        this.$el.find('.heading-large').text('You\'ve been invited to join ' + response.workspace).show();
                    } else {
                        this.$el.find('.heading-large').text('You\'ve been invited to join Userback').show();
                    }

                    this.$el.find('.join-submit').prop('disabled', false);

                    if (response.join_type === 'login') {
                        this.$el.find('.forgot-password').show();
                        this.$el.find('.invitation-row-name').hide().find('input[name="name"]').prop('required', false);
                        this.$el.find('.join-method').text('Confirm with your password');
                    } else if (response.join_type === 'signup') {
                        this.$el.find('.heading-large').addClass('white-space-nowrap').text('You\'ve been invited to Userback');
                        this.$el.find('.invitation-row-name').show().find('input[name="name"]').prop('required', true);
                        this.$el.find('.join-method').text('Sign up and join');
                    }

                    Form.setData(this.$el.find('form'), {
                        email: response.email
                    });
                }
            });
        } else if (this.join_code) {
            // invite link
            Cache.app.request({
                action: 'app/getInviteLink',
                data: {
                    join_code: this.join_code
                },
                anon: true,
                success: (response) => {
                    if (response.display_name) {
                        this.$el.find('.heading-large').text('Join ' + response.display_name);
                    } else {
                        this.$el.find('.heading-large').text('Join Userback');
                    }
                },
                error: () => {
                    this.$el.find('.heading-large').html('Join Userback');
                    this.$el.find('.banner-danger').html('The invite link has expired.').show();
                    this.$el.find('button:submit').prop('disabled', true);
                    this.$el.find('#openid_signin_methods').addClass('disabled');
                }
            });
        }

        if (this.form_display === 'login') {
            if (this.error_code) {
                let error_message = '';
                switch (this.error_code) {
                    case 'device_limit':
                        error_message = 'A different device has signed in to your account, please log in again.';
                        break;
                    case 'user_limit':
                        error_message = 'There are not enough user licenses available on your account, please contact support.';
                        break;
                    case 'account_error':
                        error_message = 'Your account is incorrectly configured, please contact support.';
                        break;
                    default:
                        error_message = 'An error occured, please try again';
                        break;
                }

                this.$el.find('.banner-danger')
                .text(error_message)
                .show();
            }

            var workspace_domain = Router.getQueryString('wd');
            if (workspace_domain) {
                Cache.app.request({
                    action: 'app/getWorkhostInfo',
                    data: {
                        'wd': workspace_domain
                    },
                    anon: true,
                    success: (response) => {
                        if (response.workspace) {
                            this.$el.find('.heading-large').text('Sign in to ' + response.workspace);
                        }
                    }
                });
            }

            Form.setData(this.$el.find('form'), {
                email: Router.getQueryString('email')
            });
        } else if (this.form_display === 'signup') {
            Form.setData(this.$el.find('form'), {
                name          : this.fullname,
                email         : this.email,
                referral_code : this.referral_code
            });
        } else if (this.form_display === 'workspace_select') {
            this.views.workspace_select = new View_Workspace_Select({
                show_create: true
            });
            this.views.workspace_select.render().$el.appendTo(this.$el.find('.region-workspace-select'));
        }

        this.$el.find('form input:first').focus();
    },

    setupOpenidSignin: async function () {
        window.onGoogleLibraryLoad = () => {
            google.accounts.id.initialize({
                client_id: window.app_configs.google_client_id,
                callback: (response) => {
                    this.openidSignin('google', response, {});
                },
                ux_mode: 'popup'
            });

            google.accounts.id.renderButton(
                this.$el.find('.openid-button-google').get(0), {
                    type: 'standard',
                    theme: 'outline',
                    size: 'medium',
                    shape: 'pill',
                    width: this.$el.find('.openid-button-google').width(),
                    text: this.signin_context === 'signup' ? 'signup_with' : 'signin_with'
                }
            );
        };

        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        document.head.appendChild(script);

        // Microsoft
        const msal_config = {
            auth: {
                clientId: window.app_configs.microsoft_client_id,
                authority: 'https://login.microsoftonline.com/common',
                redirect_uri: ''
            },
        };

        this.msal_instance = await PublicClientApplication.createPublicClientApplication(msal_config);
    },

    openidSignin: function(provider, payload, options) {
        payload.provider = provider;
        payload.signin_context = this.signin_context;

        if (typeof(this.invitation_key) !== 'undefined') {
            options.invitation_key = this.invitation_key;
        }

        if (this.ext_login) {
            options.ext_login = true;
        }

        options.referral_code = this.referral_code;
        options.campaign_code = this.campaign_code;

        this.openid_provider = provider;
        this.openid_payload  = payload;
        this.openid_options  = options;

        // disable sign in, sign up buttons
        this.$el.find('button:submit').prop('disabled', true).addClass('loading');

        const form_data = { 'payload': payload, 'options': options };

        var provider_name = Util.cap(provider);

        Cache.app.request({
            action: 'app/openidSignin',
            data: form_data,
            anon: true,
            success: (response) => {
                if (this.signin_context === 'delete' && response === true) {
                    // bypass Router.navigate since we're likely already on /login/ and we just want to bail out.
                    document.location.href = '/login/';
                    return;
                } else if (response.auth_success === false) {
                    var form_selector = '.' + (this.form_display === 'user_invitation' ? 'user-invitation-form' : 'login-form');

                    if (response.reason === 'refresh') {
                        document.location.href = document.location.pathname;
                        return;
                    } else if (response.reason === 'invite_expired') {
                        // in theory, the page load should handle this, so it shouldnt matter if this is a dead end:
                        this.$el.find(form_selector +' div[data-step="1"] .banner-danger').text('The invitation has expired or is invalid.').show();
                        return;
                    } else if (response.reason === 'invite_email_mismatch') {
                        this.$el.find(form_selector +' div[data-step="1"] .banner-danger').text('The email address for your '+ provider_name + ' account must match the invitation.').show();
                        return;
                    } else if (response.reason === 'invalid_account') {
                        this.$el.find(form_selector +' div[data-step="3"] .banner-danger').text('Your '+ provider_name +' account can not be used. Please enter an email and password.').show();
                        return;
                    } else if (response.reason === 'signup_required') {
                        this.$el.find(form_selector +' div[data-step="1"] .banner-danger').html('Your email address could not be found.<br/>Don\'t have an account? <a href="/signup/">Sign up</a>').show();
                        return;
                    } else if (response.reason === 'login_required' || response.reason === 'password_required') {
                        // Convert an existing email login to a federated user
                        // Need to confirm password
                        this.$el.find(form_selector +' div[data-step="3"] .heading-large').text('Convert email login to ' + provider_name);
                        this.$el.find(form_selector +' div[data-step="3"] .heading-desc').html('<p>You already have a login with Email. Please enter your Userback password to connect your ' + Util.htmlEntities(provider_name) + ' account.</p><p><i class="fa-solid fa-circle-exclamation text-icon"></i> Once connected, you can no longer sign in with your email and password.</p>');
                        this.$el.find(form_selector +' div[data-step="1"]').hide();
                        this.$el.find(form_selector +' div[data-step="3"]').show().find('input:first').focus();

                        if (response.reason === 'password_required') {
                            this.$el.find(form_selector +' div[data-step="3"] .banner-danger').text('You entered an incorrect email, password, or both.').show();
                        }

                        return;
                    } else if (response.reason === 'signin_required') {
                        Router.navigate('/login/?redirect=signup', {trigger: true});
                    } else if (response.reason === 'sso_domain') {
                        window.location = app_configs.sso_login_url;
                        return;
                    }
                } else {
                    // set configs because ssoRedirect needs it
                    Cache.app.configs = response.configs;

                    var sso_redirect = this.checkSSORedirect();

                    if (sso_redirect) {
                        return;
                    }

                    // empty user profile
                    if (response.user_id && response.error_msg === 'no workspaces') {
                        // hack
                        $('<div>')
                            .addClass('workspace-form')
                            .append($('<div>').addClass('region-workspace-select'))
                            .insertAfter(this.$el.find('.login-form'));

                        this.$el.find('.login-form').hide();

                        this.views.empty_profile = new View_Empty_Profile({
                            from_openid : true
                        });

                        this.views.empty_profile.render().$el.appendTo(this.$el.find('.region-workspace-select'));

                        this.views.empty_profile.on('create', () => {
                            this.signin_context = 'workspace';
                            this.openidSignin(provider, payload, options);
                        }).bind(this);

                        this.views.empty_profile.on('delete', () => {
                            this.signin_context = 'delete';
                            this.openidSignin(provider, payload, options);
                        }).bind(this);
                    } else if (response.error_msg) {
                        this.$el.find('.banner-danger')
                            .text(response.error_msg)
                            .show();
                    } else {
                        if (response.is_signup) {
                            // For consistency, this tracks both 'Signup Request' and 'Signup' even though we're bypassing the email confirmation process
                            Cache.app.trackEvent('Signup Request');

                            this.trackSignup(provider);
                        }

                        if (this.ext_login) {
                            this.loginToExt(response.auth_key);
                        } else {
                            this.loginToApp(response, response.is_signup);
                        }
                    }
                }
            },
            complete: () => {
                this.$el.find('button:submit').prop('disabled', false).removeClass('loading');
            }
        });
    },

    toggleEmailSignupForm: function(show) {
        this.$el.find('.signup-method-email').toggle(!show);
        this.$el.find('#openid_signin_methods').toggle(!show);
        this.$el.find('.signup-method-back').toggle(show);
        this.$el.find('#gtm_signup_form').toggle(show)
    },

    render: function() {
        var content = '';

        var cookie_query = [];

        if (this.signup_code) {
            cookie_query.push('c=' + this.signup_code);
        }

        if (this.campaign_code) {
            cookie_query.push('campaign_code=' + this.campaign_code);
        }

        cookie_query = cookie_query.join('&');
        cookie_query = cookie_query ? '?' + cookie_query : '';

        var signup_url = this.referral_code ? '/signup/r/' + this.referral_code : '/signup/';

        signup_url += cookie_query;

        if (!Cache.app.isGenericHost()) {
            signup_url = Cache.app.host + signup_url;
        }

        const signin_buttons = {};

        var signin_text = 'Sign in';
        if (this.signin_context === 'signup') {
            signin_text = 'Sign up';
        }

        signin_buttons.google =
            '<div class="openid-button' + (this.form_display === 'login' ? ' tooltip' : '') + '" data-title="' + signin_text + ' with Google">' +
                '<div class="openid-button-google"></div>' +
                '<button type="button" class="openid-button-google-overlay">' +
                    SVG.google +
                    '<span class="text">' + signin_text + ' with&nbsp;</span>Google' +
                '</button>' +
            '</div>';

        signin_buttons.microsoft =
            '<div class="openid-button' + (this.form_display === 'login' ? ' tooltip' : '') + '" data-title="' + signin_text + ' with Microsoft">' +
                '<button type="button" class="openid-button-microsoft" data-type="microsoft">' +
                    SVG.microsoft +
                    '<span class="text">' + signin_text + ' with&nbsp;</span>Microsoft' +
                '</button>' +
            '</div>';

        signin_buttons.sso =
            '<div class="openid-button tooltip" data-title="' + signin_text + ' with SSO">' +
                '<button type="button" class="openid-button-sso" data-type="sso">SSO</button>' +
            '</div>';

        let openid_signin = true;

        var openid_confirm_step =
            '<div data-step="3">' +
                '<div class="heading-large margin-bottom-12"></div>' +
                '<div class="heading-desc"></div>' +
                '<form class="openid-password-confirm form-fluid">' +
                    '<div class="banner-danger"></div>' +
                    '<div class="row">' +
                        '<div class="field-label">Password</div>' +
                        '<div class="position-relative">' +
                            '<input type="password" name="password" class="userback-ignore solid medium" maxlength="255" autocomplete="new-password" required>' +
                            '<button type="button" class="password-toggle"></button>' +
                        '</div>' +
                    '</div>' +
                    '<button class="primary medium full">Submit</button>' +
                '</form>' +
            '</div>';

        if (this.form_display === 'login') {
            content +=
            '<div class="login-form">' +
                '<div>' +
                    '<div class="logo"><a href="https://userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
                    // login form
                    '<div data-step="1">' +
                        '<div class="heading-large">' +
                            (Router.getQueryString('redirect') === 'signup' ?
                            'Looks like you already have an account, please sign in.' : 'Welcome Back') +
                        '</div>' +

                        '<form class="login-auth form-fluid">' +
                            '<div class="banner-danger"></div>' +
                            '<div class="row">' +
                                '<div class="field-label">Email</div>' +
                                '<input type="email" name="email" class="solid medium" maxlength="200" required>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Password</div>' +
                                '<div class="position-relative">' +
                                    '<input type="password" name="password" class="login-password userback-ignore solid medium" maxlength="255" required>' +
                                    '<button type="button" class="password-toggle"></button>' +
                                '</div>' +
                            '</div>' +
                            '<button class="primary medium full sign-in">Sign in</button>' +
                        '</form>' +

                        '<div class="hr margin-top-4"><span class="text-info">or</span></div>' +
                        '<div id="openid_signin_methods" class="short">' +
                            (window.app_configs.google_client_id ? signin_buttons.google : '') +
                            (window.app_configs.microsoft_client_id ? signin_buttons.microsoft : '') +
                            (window.app_configs.sso_login_url ? signin_buttons.sso : '') +
                        '</div>' +

                        '<div class="flex-between">' +
                            (this.ext_login ? '<div></div>' :
                            '<div class="join-us text-info">Don\'t have an account? <a href="' + signup_url + '" class="primary' + (Cache.app.isGenericHost() ? ' navigation' : '') + '">Sign up</a></div>') +
                            '<div class="forgot-password"><a href="/password/forgot' + cookie_query + '" class="primary navigation">Forgot password?</a></div>' +
                        '</div>' +
                    '</div>' +
                    // login 2FA
                    '<div data-step="2">' +
                        '<div class="heading-large">' +
                            (Router.getQueryString('redirect') === 'signup' ?
                            'Looks like you already have an account, please sign in.' : 'Welcome Back') +
                        '</div>' +
                        '<div class="heading-desc">Your login code has been sent to <strong class="2fa-email"></strong>.</div>' +
                        '<div class="margin-bottom-16">Please enter your 6-digit code</div>' +
                        '<form class="login-2fa">' +
                            '<div class="banner-danger"></div>' +
                            '<div class="code-input code-input-6">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                            '</div>' +
                        '</form>' +
                        '<div class="code-resend"><a href="#" class="primary">Didn\'t receive the code? Resend.</a></div>' +
                    '</div>' +
                    openid_confirm_step +
                '</div>' +
            '</div>';
        } else if (this.form_display === 'signup' || this.form_display === 'join_workspace') {
            content +=
            '<div class="signup-form">' +
                '<div>' +
                    '<div class="logo"><a href="https://userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
                    '<div data-step="1">' +
                        (this.form_display === 'signup' ?
                        '<button type="button" class="signup-method-back small tertiary round square margin-bottom-16"><i class="fa-solid fa-chevron-left"></i></button>' +
                        '<div class="heading-large">Create your free account</div>' :
                        '<div class="heading-large"></div>') +

                        '<form class="signup-method-email form-fluid">' +
                            '<div class="banner-danger"></div>' +
                            '<input type="email" name="email" class="solid medium" maxlength="200" placeholder="Your work email" required>' +
                            '<button class="primary medium full margin-top-16">Continue with Email</button>' +
                        '</form>' +

                        (window.app_configs.google_client_id ?
                        '<div id="openid_signin_methods">' +
                            '<div class="hr margin-top-4"><span class="text-info">or</span></div>' +
                            signin_buttons.google + signin_buttons.microsoft +
                        '</div>' : '') +

                        '<form id="gtm_signup_form" class="form-fluid">' +
                            '<div class="banner-danger"></div>' +
                            '<div class="row">' +
                                '<div class="field-label">Email address</div>' +
                                '<input type="email" name="email" class="solid medium" maxlength="200" placeholder="Your work email" required>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Your name</div>' +
                                '<input type="text" name="name" class="solid medium" maxlength="100" placeholder="What should we call you?" required>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Password</div>' +
                                '<div class="position-relative">' +
                                    '<input type="password" name="password" class="userback-ignore solid medium" maxlength="255" placeholder="Minimum 8 characters" autocomplete="new-password" required>' +
                                    '<button type="button" class="password-toggle"></button>' +
                                '</div>' +
                            '</div>' +
                            '<button class="primary medium full">' + (this.form_display === 'join_workspace' ? 'Continue' : 'Sign Up') + '</button>' +
                            '<input type="hidden" name="referral_code">' +
                        '</form>' +
                        '<div class="divider-12"></div>' +
                        '<div class="tnc text-info">By continuing, you agree to our <a href="https://userback.io/terms" class="primary" target="policy">Terms</a> and <a href="https://userback.io/privacy" class="primary" target="policy">Privacy Policy</a></div>' +
                        '<div class="log-in text-info">Already a Userbacker? <a href="/login/' + cookie_query + '" class="navigation primary">Log in</a></div>' +
                    '</div>' +
                    '<div data-step="2">' +
                        '<div class="heading-large margin-bottom-12">Confirm your email address</div>' +
                        '<div class="heading-desc">We sent a confirmation code to<br><b class="confirm-email"></b></div>' +
                        '<div class="margin-bottom-16">Please enter your 6-digit code below to continue</div>' +
                        '<form class="signup-confirm">' +
                            '<div class="banner-danger"></div>' +
                            '<div class="banner-success"></div>' +
                            '<div class="code-input code-input-6">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                                '<input type="text" inputmode="numeric" maxlength="1">' +
                            '</div>' +
                        '</form>' +
                        '<div class="flex-start margin-top-48">' +
                            '<a class="open-mail-client" href="https://mail.google.com" target="email_client" rel="noopener"><img src="/image/gmail_logo.png">Open Gmail</a>' +
                            '<a class="open-mail-client" href="https://outlook.live.com" target="email_client" rel="noopener"><img src="/image/outlook_logo.png">Open Outlook</a>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>';
        } else if (this.form_display === 'forgot_password') {
            openid_signin = false;
            content +=
            '<div class="forgot-password-form">' +
                '<div>' +
                    '<div class="logo"><a href="https://userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
                    '<div class="heading-large margin-bottom-12">Forgot your password?</div>' +
                    '<div class="heading-desc">We\'ll send you a link to reset your password</div>' +
                    '<form class="form-fluid">' +
                        '<div class="banner-success"></div>' +
                        '<div class="row">' +
                            '<div class="field-label">Email</div>' +
                            '<input type="email" name="email" class="solid medium" maxlength="200" autocomplete="new-password" required>' +
                        '</div>' +
                        '<button class="primary medium full">Request Reset Link</button>' +
                    '</form>' +
                    '<div class="log-in text-info">Know your password? <a href="/login/' + cookie_query + '" class="navigation primary">Log in</a></div>' +
                '</div>' +
            '</div>';
        } else if (this.form_display === 'reset_password') {
            openid_signin = false;
            content +=
            '<div class="reset-password-form">' +
                '<div>' +
                    '<div class="logo"><a href="https://userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
                    '<div class="heading-large margin-bottom-12">Set your new password</div>' +
                    '<div class="heading-desc">Enter your new password below.</div>' +
                    '<form class="form-fluid">' +
                        '<div class="banner-danger"></div>' +
                        '<div class="banner-success"></div>' +
                        '<div class="row">' +
                            '<div class="field-label">New password</div>' +
                            '<div class="position-relative">' +
                                '<input type="password" name="password" class="userback-ignore solid medium" maxlength="255" autocomplete="new-password" required>' +
                                '<button type="button" class="password-toggle"></button>' +
                            '</div>' +
                        '</div>' +
                        '<input type="hidden" name="key" value="' + Util.htmlEntities(this.password_reset_key) + '">' +
                        '<button class="primary medium full">Reset Password</button>' +
                    '</form>' +
                    '<div class="log-in"><a href="/login/' + cookie_query + '" class="navigation primary">Know your password?  Log in</a></div>' +
                '</div>' +
            '</div>';
        } else if (this.form_display === 'user_invitation') {
            content +=
            '<div class="user-invitation-form">' +
                '<div>' +
                    '<div class="logo"><a href="https://userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
                    '<div data-step="1">' +
                        '<div class="heading-large margin-bottom-12">You\'ve been invited to join workspace</div>' +
                        '<div class="heading-desc join-method"></div>' +

                        '<form class="invite-auth form-fluid">' +
                            '<div class="banner-danger"></div>' +
                            '<div class="row">' +
                                '<div class="field-label">Email</div>' +
                                '<input type="email" name="email" class="solid medium" maxlength="200" required disabled>' +
                            '</div>' +
                            '<div class="row invitation-row-name" style="display:none;">' +
                                '<div class="field-label">Name</div>' +
                                '<input type="text" name="name" class="solid medium" maxlength="100">' +
                            '</div>' +
                            '<div class="row invitation-row-password">' +
                                '<div class="field-label">Password</div>' +
                                '<div class="position-relative">' +
                                    '<input type="password" name="password" class="userback-ignore solid medium" maxlength="255" autocomplete="new-password" required>' +
                                    '<button type="button" class="password-toggle"></button>' +
                                '</div>' +
                            '</div>' +
                            '<input type="hidden" name="key" value="' + this.invitation_key + '">' +
                            '<button class="primary medium full join-submit">Accept Invitation</button>' +
                            '<div class="forgot-password" style="display:none;"><a href="/password/forgot" class="primary navigation">Forgot password?</a></div>' +
                        '</form>' +

                        (window.app_configs.google_client_id ?
                        '<div class="hr"><span class="text-info">or</span></div>' +
                        '<div id="openid_signin_methods">' + signin_buttons.google + signin_buttons.microsoft + '</div>' : '') +

                        '<p class="tnc info">By continuing, you agree to our <a href="https://userback.io/terms" class="primary" target="policy">Terms</a> and <a href="https://userback.io/privacy" class="primary" target="policy">Privacy Policy</a></p>' +
                    '</div>' +
                    openid_confirm_step +
                '</div>' +
            '</div>';
        } else if (this.form_display === 'workspace_select') {
            openid_signin = false;
            content +=
            '<div class="workspace-form">' +
                '<div>' +
                    '<div class="region-workspace-select"></div>' +
                '</div>' +
            '</div>';
        } else if (this.form_display === 'sso_domain') {
            openid_signin = false;
            content +=
            '<div class="sso-domain-display">' +
                '<div>' +
                    '<div class="logo"><a href="https://userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
                    '<div class="heading-large margin-bottom-12">Your team has already been set up.</div>' +
                    '<div class="heading-desc">We cannot create a new account for you because your team has already been set up in Userback.<br><br>Please contact your administrator to be invited.</div>' +
                    '<div class="log-in text-info">Problems signing in? <a href="https://support.userback.io/en/" class="navigation primary">Contact us</a></div>' +
                '</div>' +
            '</div>';
        }

        this.$el.html(content);

        // This runs after the google signin elements are on the page:
        if (openid_signin) {
            this.setupOpenidSignin();
        }

        return this;
    }
});
